import React from 'react';
import { Spacer } from '@ontruck/orc';

import BeforeAndAfterWithArrow from './utils/BeforeAndAfterWithArrow';
import VehicleExtra from './utils/VehicleExtra';
import StopChange from './utils/StopChange';
import { t, EXTRAS, fieldHasChanges } from './utils/constants';

import { HeightCell, AmountCell } from 'utils/format';

const updateShipperOrderRenderer = ({ changes }) => {
  return (
    <div>
      {fieldHasChanges(changes?.shipper) && (
        <BeforeAndAfterWithArrow
          label={t.shipper}
          before={changes?.shipper?.before}
          after={changes?.shipper?.after}
        />
      )}
      {fieldHasChanges(changes?.user) && (
        <BeforeAndAfterWithArrow
          label={t.user}
          before={changes?.user?.before}
          after={changes?.user?.after}
        />
      )}
      {fieldHasChanges(changes?.net_full_price) && (
        <BeforeAndAfterWithArrow
          label={t.price}
          before={changes?.net_full_price?.before}
          after={changes?.net_full_price?.after}
          valueFormatter={(value) => (
            <AmountCell currency={changes?.currency?.after} value={value} />
          )}
        />
      )}
      <Spacer mTop="XS">
        {changes?.stops?.map((stop, key) => (
          <StopChange stop={stop} key={key} />
        ))}
      </Spacer>
      <Spacer mBottom="XS">
        {fieldHasChanges(changes?.vehicle_extras) && (
          <>
            <VehicleExtra
              vehicleExtras={changes?.vehicle_extras}
              extra={EXTRAS.LIFTGATE}
              label={t.LIFTGATE}
            />
            <VehicleExtra
              vehicleExtras={changes?.vehicle_extras}
              extra={EXTRAS.SIDE_LOAD}
              label={t.SIDE_LOAD}
            />
            <VehicleExtra
              vehicleExtras={changes?.vehicle_extras}
              extra={EXTRAS.TOP_LOAD}
              label={t.TOP_LOAD}
            />
          </>
        )}
        {fieldHasChanges(changes?.max_height) && (
          <BeforeAndAfterWithArrow
            label={t.max_height}
            before={changes?.max_height?.before}
            after={changes?.max_height?.after}
            valueFormatter={(value) => <HeightCell height={value} />}
          />
        )}
      </Spacer>
    </div>
  );
};

export default updateShipperOrderRenderer;
